import ExportBase from "../exportbase";


import LabelDialog from "../../../../../dialogs/labeldialog";

import DialogInputBox from "../../../../../dialogs/inputbox";


import React from "react";

class ExportTXTST extends ExportBase 
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {
        timecode:false,
        stnumber:false,
    }
        
    
    this.timecodeRef = React.createRef();
    this.stnumberRef = React.createRef();



    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();
    
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

createWorker()
{
    
    return new Worker(new URL('./txtstworker.js', import.meta.url));
}

sendFormulaire()
{
    
    var datas = {};
    datas = {
        timecode : this.timecodeRef.current.getValue(),
        stnumber : this.stnumberRef.current.getValue(),
    }
    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
               this.lastFormulaireSend = JSON.stringify(datas);
            this.startComputeFile(datas)
    }

    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{
   
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <DialogInputBox
        value = {this.state.formulaire.timecode}
        disabled={false}
        autoFocus = {false}
        ref = {this.timecodeRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec time codes":" With TimeCode"}
        />
        <br/>

        <DialogInputBox
        value = {this.state.formulaire.stnumber}
        disabled={false}
        autoFocus = {false}
        ref = {this.stnumberRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec numéros de sous-titres":" With Subtitle Number"}
        />

    </>
        
    )
}
}

export default ExportTXTST;